import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "customiz3r:autosave";

const readStoredPreference = () => {
    try {
        // Ausente = desactivado: guardar solo el diseño de otro es una decisión
        // que toma el usuario, no algo que se le active sin pedirlo.
        return window.localStorage.getItem(STORAGE_KEY) === "on";
    } catch {
        // Modo privado o almacenamiento bloqueado: se queda en el defecto.
        return false;
    }
};

/**
 * Preferencia de autoguardado del editor. **Desactivada por defecto.**
 *
 * Es del usuario, no del diseño: se guarda en localStorage y vale para
 * cualquier producto (llavero, caja de luz…), igual que el tema.
 */
export default function useAutoSavePreference() {
    const [autoSaveEnabled, setAutoSaveEnabled] = useState(readStoredPreference);

    useEffect(() => {
        try {
            window.localStorage.setItem(STORAGE_KEY, autoSaveEnabled ? "on" : "off");
        } catch {
            /* sin persistencia: la preferencia dura lo que la sesión */
        }
    }, [autoSaveEnabled]);

    const toggleAutoSave = useCallback((value) => {
        setAutoSaveEnabled(previous => (typeof value === "boolean" ? value : !previous));
    }, []);

    return [autoSaveEnabled, toggleAutoSave];
}
